<template>
  <div class="content if-profile report-tab">
    <div class="md-layout ratios-report">
      <MRReportHeader :headerData="this.headerData"/>

      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 marketprof-competitors p-0">
        <!-- <div class="finanical-report-messages">
          <h1 class="md-subheading profile-title">Penetration</h1>
          <div class="">
            <md-dialog :md-active.sync="showDialog">
              <p>
                Is your industry market saturated or under‐served? Whether sales
                per person, per household or per area business operation metrics
                are most appropriate to your industry, our “Sales Per” metrics
                offer an insight into whether your market area is outperforming
                or underperforming national levels. Although all three metrics
                are presented, only or two may be relevant to your industry. For
                example, retail sales will find local-national Sales per Person
                and Sales per Household comparisons useful, while wholesalers
                may rely more on Business Site metrics. Note: The Sales per
                business Site measure is not displayed here but can be found in
                your IMR File-2, and may be more relevant for specific types of
                (especially B2B businesses).
              </p>
            </md-dialog>
            <md-card-header class="md-card-header-icon messages-box">
              <div class="card-icon md-ripple" @click="showDialog = true">
                <md-icon class="icon-arrow">double_arrow </md-icon>
                <md-icon>chat_bubble</md-icon>
              </div>
            </md-card-header>
          </div>
        </div> -->
        <div class=" md-transparent finanical-report-messages">
          <nav-tabs-card class="p-0 m-0">
            <template slot="content">
              <div class="md-layout">
                <div class="md-layout-item md-size-100  blue-tbl p-0">
                  <md-card class="if_card">
                    <md-card-header>Penetration</md-card-header>
                    <md-card-content>
                      <div class="md-layout p-4">
                        <div class="md-layout-item md-size-100">
                          <md-card class="md-card-profile">
                            <md-card-header class="md-card-header-icon">
                              <h4 class="title m-0">
                                <div
                                  class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                >
                                  Market Penetration ($)
                                </div>
                              </h4>
                              <!-- <h4 class="title text-left">Market Penetration ($)</h4> -->
                            </md-card-header>
                            <md-card-content>
                              <div class="md-layout">
                                <div
                                  class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                                >
                                  <md-table
                                    v-model="tableDataMarketPenetration"
                                    table-header-color="blue"
                                    class="profit-and-loss-table"
                                  >
                                    <md-table-row
                                      slot="md-table-row"
                                      slot-scope="{ item }"
                                    >
                                      <md-table-cell
                                        class="md-table-side-label"
                                        >{{ item.name }}</md-table-cell
                                      >
                                      <md-table-cell
                                        v-for="key in Object.keys(item.dates)"
                                        :key="key"
                                        :md-label="years[key]"
                                        >{{ item.dates[key] }}
                                      </md-table-cell>
                                    </md-table-row>
                                  </md-table>
                                </div>
                              </div>
                            </md-card-content>
                          </md-card>
                        </div>
                        <div
                          class="md-layout-item md-medium-size-100 md-size-50"
                        >
                          <md-card class="md-card-profile">
                            <md-card-content>
                              <chart-card
                                header-animation="false"
                                :chart-data="colouredLineChart.data"
                                :chart-options="colouredLineChart.options"
                                chart-type="Line"
                                header-icon
                                chart-inside-content
                                no-footer
                                background-color="blue"
                              >
                                <template slot="chartInsideHeader">
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >
                                      {{ release_display }} Market Penetration
                                      ($)
                                    </div>
                                  </h4>
                                  <!-- <h4 class="title">
                                    {{ release_display }} Market Penetration ($)
                                  </h4> -->
                                </template>
                              </chart-card>
                              <div class="pie-line">
                                <ul>
                                  <li><span class=""><i class="fa fa-square blue-color"></i></span> US Sales / Household</li>
                                    <li><span class=""><i class="fa fa-square yellow-color"></i></span> Market Sales / Household</li>
                                    <li><span class=""><i class="fa fa-square red-color"></i></span>US Sales / Person</li>
                                     <li><span class=""><i class="fa fa-square sky-blue-color"></i></span> Market Sales / Person</li>

                                </ul>
                                    </div>
                            </md-card-content>
                          </md-card>
                        </div>
                         <div class="md-layout-item md-medium-size-100 md-size-50">
                          <md-card class="md-card-profile">
                            <md-card-header>
                              <h4 class="title m-0">
                                <div
                                  class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                >
                                  Competitive Market Narrative
                                </div>
                              </h4>
                            </md-card-header>
                            <md-card-content>
                              <div class="extra_space">
                                <!-- <h4 class="Performance Scores">
                                  Competitive Market Narrative
                                </h4> -->
                                <p>
                                  {{cmnText.penetration}}
                                </p>
                              </div>
                            </md-card-content>
                          </md-card>
                          <md-card class="md-card-profile ">
                            <md-card-header>
                              <h4 class="title m-0">
                                <div
                                  class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                >
                                  <md-icon class="color-white">article</md-icon> Penetration
                                </div>
                              </h4>
                            </md-card-header>
                            <md-card-content>
                              <div class="md-layout">
                                <div class="md-layout-item md-medium-size-100 md-size-100">
                                  <div class="extra_space">
                                    <!-- <h4 class="Performance Scores">
                                          Competitive Market Narrative
                                    </h4>-->
                                    <p>
                                      Is your industry market saturated or under‐served? Whether sales per person, per household or per area
                                      business operation metrics are most appropriate to your industry, our "Sales Per" metrics offer an insight
                                      into whether your market area is outperforming or underperforming national levels. Although all three metrics are
                                      presented, only or two may be relevant to your industry. For example, retail sales will find local-national Sales
                                      per Person and Sales per Household comparisons useful, while wholesalers may rely more on Business Site metrics. Note:
                                      The Sales per business Site measure is not displayed here but can be found in your IMR File-2,
                                      and may be more relevant for specific types of (especially B2B businesses).
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </md-card-content>
                          </md-card>
                        </div>
                        <div
                          class="md-layout-item md-medium-size-100 "
                        >

                        </div>
                      </div>
                    </md-card-content>
                  </md-card>
                </div>
              </div>
            </template>
          </nav-tabs-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ChartCard, NavTabsCard } from '@/components';
import { mapState } from 'vuex';
import MRReportHeader from './_partials/MRReportHeader.vue';

export default {
  components: {
    ChartCard,
    NavTabsCard,
    MRReportHeader,
  },
  computed: {
    ...mapState({
      penetration: (state) => state.user.market_report.data.data['penetration'],
      years: (state) => state.user.market_report.data.years,
      release_display: (state) =>
        state.user.market_report.data.general['release_display'],
      cmnText: (state) =>state.user.market_report.cmnText,
    }),
  },
  props:['headerData'],
  data() {
    return {
      view: 'cash-flow-solvency',
      showDialog: false,
      tableDataMarketPenetration: [],

      colouredLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 40,
          },
          axisX: {
            showGrid: false,
          },
          showPoint: true,
          height: '300px',
        },
      },
    };
  },
  mounted() {
    let section = this.$route.query.section;

    if (!section) {
      section = 'cash-flow-solvency';
    }

    this.switchView(section);
    this.tableDataMarketPenetration = Object.entries(
      this.penetration
    ).map(([table, data]) => ({ name: table, dates: Object.values(data) }));
    let me = this;
    this.tableDataMarketPenetration.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithCommas(e);
      });
      return item;
    });
    let newTableMarketPenetration = Object.entries(
      this.penetration
    ).map(([table, data]) => ({ name: table, dates: Object.values(data) }));
    newTableMarketPenetration.map((item) => {
      item.dates = item.dates.map((e) => {
        return Number(e);
      });
      return item;
    });
    this.colouredLineChart.data = {
      labels: this.years,
      series: newTableMarketPenetration.map((item) => ({
        name: item.name,
        data: item.dates,
      })),
    };
  },
  watch: {
    '$route.query.section'() {
      let section = this.$route.query.section;

      if (!section) {
        section = 'cash-flow-solvency';
      }

      this.switchView(section);
    },
  },
  methods: {
    switchView: function(type) {
      this.view = type;
    },
    numberWithCommas(x) {
      if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      } else {
        return x;
      }
    },
  },
};
</script>
<style lang="scss">
.marketprof-competitors {
  .md-toolbar {
    .md-collapse {
      display: block;

      .md-collapse-content {
        p {
          padding-left: 20px;
        }
      }
    }
  }

  .competitors-list {
    .md-collapse-title {
      font-size: 12px;
      font-weight: 300;
      margin-left: 25px;
    }
    .md-icon {
      font-size: 12px;
      font-weight: 300;
      transform: rotate(-90deg);
      left: 0;
      color: rgba(0, 0, 0, 0.54);
    }
  }

  .competitors-map {
    iframe {
      height: 300px !important;
    }
  }
}
</style>
